<script>
import CleaningCard from './cleaning_card.vue'
export default {
  extends: CleaningCard,
  data() {
    return { plan: 'upkeep' }
  }
}
</script>
